import { IMG, COMPANY } from "@/lib/site";
import { Reveal, Eyebrow } from "@/components/Reveal";

export const About = () => (
  <section id="ueber-uns" data-testid="about-section" className="relative w-full bg-white text-[#0a0a0a] py-20 sm:py-24 lg:py-32">
    <div className="w-full px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
      <div className="lg:col-span-6 relative">
        <Reveal className="relative overflow-hidden">
          <img src={IMG.heroVan} alt="Transporter von Global Move Europa" loading="lazy" className="w-full h-[40vh] sm:h-[52vh] lg:h-[66vh] object-cover" />
        </Reveal>
        <Reveal delay={0.15} className="hidden sm:block absolute -bottom-10 right-6 lg:right-[-40px] w-44 lg:w-60 border-8 border-white shadow-2xl overflow-hidden">
          <img src={IMG.palletsDark} alt="Palette im Lager" loading="lazy" className="w-full h-36 lg:h-48 object-cover" />
        </Reveal>
        <Reveal delay={0.2} className="absolute top-5 left-5 bg-[#f95700] px-4 sm:px-5 py-3 sm:py-4">
          <div className="eyebrow text-white/80">Standort</div>
          <div className="font-display text-xl sm:text-2xl font-black uppercase text-white leading-none mt-1">
            {COMPANY.city}
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-6">
        <Reveal>
          <Eyebrow chapter="08" dark>
            Über uns
          </Eyebrow>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display uppercase font-black leading-[0.9] tracking-tight text-[clamp(2.1rem,7vw,4.2rem)]">
            Ein Team, das<br />
            <span className="text-[#f95700]">anpackt.</span>
          </h2>
        </Reveal>
        <div className="mt-7 space-y-5 text-[15px] sm:text-base text-neutral-700 leading-relaxed max-w-2xl">
          <Reveal delay={0.08}>
            <p>
              Global Move Europa ist ein Transport- und Umzugsunternehmen mit Sitz in der{" "}
              {COMPANY.street} in {COMPANY.zip} {COMPANY.city}. Von hier aus fahren wir Transporte
              und Umzüge in Bremen und der Region, deutschlandweit und europaweit.
            </p>
          </Reveal>
          <Reveal delay={0.12}>
            <p>
              Uns ist wichtig, dass Sie wissen, mit wem Sie sprechen. Sie erreichen uns direkt,
              schildern Ihr Vorhaben und bekommen eine ehrliche Einschätzung: welches Fahrzeug,
              wie viele Helfer, welcher Zeitrahmen. Erst danach entsteht ein Angebot.
            </p>
          </Reveal>
          <Reveal delay={0.16}>
            <p>
              Am Transporttag zählt Sorgfalt. Möbel werden abgedeckt, empfindliche Stücke gesondert
              behandelt, Ladung wird gesichert. Wir arbeiten zügig, aber nie auf Kosten Ihrer
              Ladung. Am Ende soll alles dort stehen, wo es hingehört.
            </p>
          </Reveal>
        </div>

        <div className="mt-8 grid sm:grid-cols-3 gap-px bg-neutral-200">
          {[
            ["Privat & Gewerbe", "Beide Bereiche aus einer Hand"],
            ["Direkter Kontakt", "Telefon oder WhatsApp"],
            ["Bremen als Basis", `${COMPANY.street}, ${COMPANY.zip}`],
          ].map(([a, b], i) => (
            <Reveal key={a} delay={0.06 * i} className="bg-white p-5 sm:p-6">
              <div className="font-display text-base sm:text-lg font-bold uppercase leading-tight">{a}</div>
              <div className="font-mono-t text-[11px] text-neutral-500 mt-1.5">{b}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
